import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Avatar, CircularProgress } from "@mui/material";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import { useIntl } from "react-intl";
import AppsContainer from "@crema/core/AppsContainer";
import AppInfoView from "@crema/core/AppInfoView";
import { getPlansCountDashboard } from "redux/actions/planMaster";

const DashboardData = () => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
    const planState = useSelector((state: any) => state.planMaster ?? {});
  const {
    dashboardCounts = { totalPlans: 0, activePlans: 0, inactivePlans: 0, newPlans: 0 },
    loading = false,
  } = planState;

  const { totalPlans, activePlans, inactivePlans, newPlans } = dashboardCounts;

  useEffect(() => {
    dispatch(getPlansCountDashboard() as any);
  }, [dispatch]);

  return (
    <>
      <AppsContainer
        title={
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "text.primary",
              }}
            >
              {messages["sidebar.dashboard"]}
            </Typography>
          </Box>
        }
        fullView
      >
        {loading ? (
          <Box
            sx={{
              height: "60vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box
            sx={{
              backgroundColor: "#ffffff",
              padding: 8,
              width: "100%",
              display: "flex",
              gap: 4,
              flexWrap: "wrap",
            }}
          >
            <InfoCard title="Total Plans" count={totalPlans} color="#3f51b5" />
            <InfoCard title="Active Plans" count={activePlans} color="#4caf50" />
            <InfoCard
              title="Inactive Plans"
              count={inactivePlans}
              color="#f44336"
            />
            <InfoCard title="New Plans" count={newPlans} color="#ff9800" />
          </Box>
        )}
      </AppsContainer>
      <AppInfoView />
    </>
  );
};

const InfoCard = ({
  title,
  count,
  color,
}: {
  title: string;
  count: number;
  color: string;
}) => (
  <Box
    sx={{
      width: 250,
      height: 100,
      bgcolor: "#fff",
      borderRadius: 3,
      boxShadow: 2,
      p: 3,
      position: "relative",
    }}
  >
    <Avatar
      sx={{
        bgcolor: color,
        position: "absolute",
        top: -20,
        left: 20,
        width: 40,
        height: 40,
      }}
    >
      <SmartphoneIcon />
    </Avatar>
    <Box sx={{ mt: 6 }}>
      <Typography variant="h6" fontWeight="bold">
        {title}
      </Typography>
      <Typography variant="body2">{count}</Typography>
    </Box>
  </Box>
);

export default DashboardData;
